import { useContext } from "react";
import { OspApiClientContext } from "@features";

type feedbackType = "thumb_up" | "thumb_down";

export const useFeedback = () => {
  const { chatApi } = useContext(OspApiClientContext);

  const feedback = async (messageId: string, type: feedbackType) => {
    await chatApi?.chats.feedbackCreate(messageId, {
      type,
    });
  };

  return {
    feedback,
  };
};
